import {ROUTES} from "../../../routes";

export const LayoutType = {
  Layout1: 1,
  Layout2: 2,
  Layout3: 3,
  Layout4: 4,
  Layout5: 5,
  Layout6: 6,
  Layout7: 7,
  Layout8: 8,
  Layout9: 9,
  Layout10: 10,
  Layout11: 11,
  Layout12: 12,
  Layout13: 13,
  Layout14: 14,
  Layout15: 15,
  Layout16: 16,
  Layout17: 17,
  Layout18: 18,
  Layout19: 19,
  Layout20: 20,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Layout1: "Layout1",
  Layout2: "Layout2",
  Layout3: "Layout3",
  Layout4: "Layout4",
  Layout5: "Layout5",
  Layout6: "Layout6",
  Layout7: "Layout7",
  Layout8: "Layout8",
  Layout9: "Layout9",
  Layout10: "Layout10",
  Layout11: "Layout11",
  Layout12: "Layout12",
  Layout13: "Layout13",
  Layout14: "Layout14",
  Layout15: "Layout15",
  Layout16: "Layout16",
  Layout17: "Layout17",
  Layout18: "Layout18",
  Layout19: "Layout19",
  Layout20: "Layout20",
};

export const LayoutAbbreviations = [
  "Layout1",
  "Layout2",
  "Layout3",
  "Layout4",
  "Layout5",
  "Layout6",
  "Layout7",
  "Layout8",
  "Layout9",
  "Layout10",
  "Layout11",
  "Layout12",
  "Layout13",
  "Layout14",
  "Layout15",
  "Layout16",
  "Layout17",
  "Layout18",
  "Layout19",
  "Layout20",
];
export const LayoutAbbreviationsToRemove = [
  "Layout20",
  "Layout19",
  "Layout18",
  "Layout17",
  "Layout16",
  "Layout15",
  "Layout14",
  "Layout13",
  "Layout12",
  "Layout11",
  "Layout10",
  "Layout9",
  "Layout8",
  "Layout7",
  "Layout6",
  "Layout5",
  "Layout4",
  "Layout3",
  "Layout2",
  "Layout1",
];

export const METADATA = {
  ALL: "ALL",
  NO: "NO",
  LeftSide: "L", // used as side for shower grab bars
  RightSide: "R", // used as side for shower grab bars
  Center: "C", // used as side for shower doors and others
  Inner: "T", // used for sinks & faucets
  Outer: "S", // used for sinks & faucets,
  StandAlone: "ST", // used for sinks & faucets,
  SingleHole: "Single Hole Faucets", // used for sinks & faucets,
  WallHungSinks: "Wall Hung Sinks", // used for sinks & faucets,
  WidespreadFaucets: "Widespread Faucets", // used for sinks & faucets,
  BathtubWithEnclosures: "Drop-in", // used for bathtubs & enclosures,
  BathtubWithoutEnclosures: "StandAlone", // used for bathtubs & enclosures,
};

export const ShowerComboTubType = {
  bathtub_liner: "bathtub_liner",
  replacement_tub: "replacement_tub",
  walk_in_tub: "walk_in_tub",
  jetted_tub: "jetted_tub",
};

export const CountsType = {
  allLayoutFeaturesCount: "All",  // not used
  largeLayoutFeaturesCount: "Large",
  smallLayoutFeaturesCount: "Small",
  totalFeaturesCount: "Total" // not used
};

export const BathTubType = {
  Custom60in: 'Custom60in',
  FreeStanding: 'BathTubFreeStanding'
};

export const VanityTypes = {
  Complete: 'Complete',
  Custom: 'Custom'
};

export const ShowerBodyType = {
  Glass: 0,
  Door: 1
};

export const PartMenuType = {
  Simple: 0, // i.e. Toilet - doesn't have any sub-items
  Complex: 1, // i.e. Vanity - has sub-menu items, Sink, Faucet Mirror
};

export const ShowerHeadTypes = { // todo we might will change it soon, tbd
  shower_arm: "shower_arm", // old
  shower_head_bundle: "shower_head_bundle", // old
  shower_trim_kit: "shower_trim_kit", // new
  shower_fixture: "shower_fixture", // new
  shower_system: "shower_system", // new
};

export const ShowerHandTypes = { // https://qc-cdn.s3.amazonaws.com/lixil/shower_hand_logic.png
  hand_shower_kit: "hand_shower_kit",
  hand_shower_holder: "hand_shower_holder",
};

export const VANITY_TYPES = {
  // standAlone: "standAlone", // ST
  vanity_cabinet: "vanity_cabinet", // S, W, A, U
  vanity_console: "vanity_console", // T
  vanity_washstand: "vanity_washstand", // T, S, W, A, U
};

export const useNewNavLogicPartIds = ["vanity_sink", ...Object.keys(VANITY_TYPES)];

export function bathTubTypeToString(bathTypeType) {
  switch (bathTypeType) {
    case BathTubType.Custom60in:
      return 'Custom';
    case BathTubType.FreeStanding:
      return 'Complete';
  }
}
export function bathTubStringToType(bathtubString) {
  switch (bathtubString) {
    case 'custom':
      return BathTubType.Custom60in;
    case 'complete':
      return BathTubType.FreeStanding;
  }
}

export const vanityWizardFilters = ["Size", "DoorStyle", "Material", "Color"];

export const showerWizardFilters = ["Material", "DuraBathColor", "SlabColor", "TileColor", "TilePattern", "AcrylicPattern", "AcrylicColor"];

export const NotQCVanityDoorStylesFilters = ["Centennial", "Hudson", "Northbrook", "Osage", "Quebec", "Riverside", "Villager", "Zurich"];

export const COUNTERTOP_GROUP_BATHROOM = ["vanity_countertop", "vanity_backsplash"];

export const CABINET_GROUP_BATHROOM = ["vanity_cabinet", "vanity_mirror"];

export const CORNER_SHELVES_POSITIONS = ["L1","L2","L3","R1","R2","R3"];

export const TWO_SIDE_POSITIONS = ["L","R"];
export const SIDE_POSITIONS = ["L","R", "C"];
export const GRAB_BARS_POSITIONS = ["L", "R", "C", "LV", "RV", "BL", "BC", "BR"];
// L,R,C is usual shower positions, LV and RV are wall mounted shower positions, BL, BC, BR are bathtub wall positions

export const createParentPositions = (object) => {
  if (!object.layerPositions) {
    object.layerPositions = {};
  }
  SIDE_POSITIONS.forEach(position => {
    object.layerPositions[position] = null;
  })
}
export const createPageToLoadArray = (object) => {
  object.nextFeaturesPageToLoadArray = {};
  LayoutAbbreviations.forEach(layoutAbbreviation => {
    object.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
      page: 0,
      allReceived: false,
    };
  });
}

export const PAN_POSITIONS = ["L","C","R"];

export const VANITY_POSITIONS = ["L","0","R"];

export const LOOK_OPENED_TYPES = {
  edit: "edit",
  featureZoom: "featureZoom"
}

export const LOOK_FEATURE_CONTENT = {
  info: "info",
  threeD: "threeD",
  aug: "aug",
  gallery: "gallery", //todo
}

export const LOOK_OVERLAYS = {
  exit: "exit",
  intro: "intro",
  print: "print",
  reset: "reset",
  loadingCart: "loadingCart",
  questionLogin: "questionLogin",
  questionShare: "questionShare",
  questionView: "questionView",
  questionViewUpdated: "questionViewUpdated",
  questionRemove: "questionRemove",
  questionRestore: "questionRestore",
  saveSucess: "saveSucess",
  stylePairing: "stylePairing",
  styleColor: "styleColor",
  styleRemove: "styleRemove",
  styleRemoveBack: "styleRemoveBack",
  styleRemoveFeature: "styleRemoveFeature",
  notCompatiblePopup: "notCompatiblePopup",
  leadCapture: "leadCapture",
  aiPanel: "aiPanel",
}

export const LOCAL_STORAGE_KEYS = {
  introVisited: "introVisited",
  saveQuoteRequired: "saveQuoteRequired", // not used anymore
  requiredShareButton: "requiredShareButton" // not used anymore
}

// export let LOOK_INTRO_STEPS = {
//   welcome: 0,
//   // edit: 1,
//   aiStep: 1,
//   layoutsAndRooms: 2,
//   wallsAndFloor: 3,
//   saveAndMore: 4,
//   review: 5,
// }
//
// export let LOOK_INTRO_STEPS = {
//   welcome: 0,
//   aiStep: 1,
//   wallsAndFloor: 2,
//   layouts: 3,
//   saveAndMore: 4,
//   rooms: 5,
//   review: 6,
// }

export const LOOK_INTRO_STEPS = {
  welcome: "welcome",
  // edit: "edit,
  aiStep: "aiStep",
  layoutsAndRooms: "layoutsAndRooms",
  wallsAndFloor: "wallsAndFloor",
  layouts: "layouts",
  saveAndMore: "saveAndMore",
  rooms: "rooms",
  review: "review",
}

let _desktopSteps = ["welcome", "aiStep", "layoutsAndRooms", "wallsAndFloor", "saveAndMore", "review"];
let _mobileSteps = ["welcome", "aiStep", "wallsAndFloor", "layouts", "saveAndMore", "rooms", "review"];

export const setCurrentIntroSteps = (fabricatorData) => {
  if (!fabricatorData.aiSettings || !fabricatorData.aiSettings.enableAI) {
    _desktopSteps = _desktopSteps.filter(step => step !== "aiStep");
    _mobileSteps = _mobileSteps.filter(step => step !== "aiStep");
  }
}

export const getCurrentIntroSteps = (isMobile) => {
  return isMobile ? _mobileSteps : _desktopSteps
}


export const CONTEXT_MENU_VANITY_ONLY = [...Object.keys(VANITY_TYPES), "vanity_legs"];
export const CONTEXT_MENU_VANITY_BUTTONS = ["vanity_faucet", "vanity_sink", "vanity_countertop", "vanity_backsplash", ...CONTEXT_MENU_VANITY_ONLY];
export const CONTEXT_MENU_BATHTUB_BUTTONS = ["bathtub_body", "bathtub_fixture"];
export const CONTEXT_MENU_SPLIT_WALL = ["split_wall", "shower_screen"];
export const CONTEXT_MENU_SHOWER_ALL = ["shower_fixture", "shower_arm", "shower_head", "shower_head_bundle",
  "hand_shower_kit", "shower_wall", "shower_door", "shower_pan_combo", "replacement_tub", "valve_trim", "replacement_tub_fixture"];
export const CONTEXT_MENU_SHOWER_OTHER = ["valve_trim", "body_spray", "wall_union", "shower_hose", "hand_shower_holder",
  "hand_shower_only", "hand_shower", "diverter_trim"];
export const CONTEXT_MENU_SHOWER_ACCESSORIES = ["shower_pod", "grab_bar", "corner_shelf", "large_corner_seat",
  "shower_seats", "soap_dish", "shower_rod", "shampoo_shelf"];

export const CONTEXT_MENU_KITCHEN_COUNTERTOPS = ["countertop", "faucet", "sink", "edge_profile"];
export const CONTEXT_MENU_KITCHEN_CENTER_ISLAND = ["center_island_sink", "center_island_faucet", "center_island_countertop",
  "center_island_stovetop", "center_island_range", "center_island_edge"];

export const ALL_CONTEXT_MENU = [
  ...CONTEXT_MENU_VANITY_BUTTONS,
  ...CONTEXT_MENU_BATHTUB_BUTTONS,
  ...CONTEXT_MENU_SPLIT_WALL,
  ...CONTEXT_MENU_SHOWER_ALL,
  ...CONTEXT_MENU_SHOWER_OTHER,
  ...CONTEXT_MENU_SHOWER_ACCESSORIES,
];

export const ALL_CONTEXT_MENU_KITCHEN = [
  ...CONTEXT_MENU_KITCHEN_CENTER_ISLAND,
  ...CONTEXT_MENU_KITCHEN_COUNTERTOPS,
];

export const DECORS_MAX = 100;

export const REQUIRE_REGEX_GROUPS = ["shower_pan_combo", "walk_in_tub", "replacement_tub", "shower_door"];

export let LOOK_WALLS = ["left_wall", "right_wall", "front_wall", "back_wall", "split_wall", "left_wall_splitter", "shower_wall", "bathroom_floor"];
for (let i = 1; i <= DECORS_MAX; i++) {
  LOOK_WALLS.push("decor_" + i);
}

export const LOOK_WALLS_ONLY = ["left_wall", "right_wall", "front_wall", "back_wall", "left_wall_splitter",
  "wainscoting", "enclosure_top", "enclosure_bottom", "center_wall", "shower_floor", "shower_curb", "pony_wall"];

export const SHOWER_WALL_WITH_SPLIT_WALL = ["split_wall", "shower_wall"];

export const POSSIBLE_ONE_POSITION = ["towel_bar", "robe_hook"];

export const WHITE_PAGE_ROUTES = [ROUTES.view, ROUTES.list, ROUTES.login, ROUTES.register, ROUTES.rooms, ROUTES.shop];

export const AVAILABLE_FILTERS = ["Color", "Material", "Collection", "Size"];

export const WIZARD_STEP_WIDTH = 184;  // 176 + 8
export const WIZARD_STEP_MOBILE_WIDTH = 96; // 88 + 8
export const WIZARD_STEP_PRODUCT_JOURNEY = 88; // 80 + 8

export const LOOK_NAVIGATION_LIST_TYPES = {
  regular: "regular",
  designRec: "designRec",
  notMatchingMeta: "notMatchingMeta"
}

export const LOOK_ROOM_TYPES = {
  as: "americanstandard",
  grohe: "grohe",
}

export const showerSideOptionsGroups = ["shower_fixture", "shower_seats", "soap_dish", "grab_bar", "shower_door",
  "shower_arm", "shower_head", "hand_shower_kit", "diverter_trim", "hand_shower_holder", "hand_shower_only",
  "shower_hose", "shower_system", "shower_trim_kit", "valve_trim", "wall_union", "shampoo_shelf", "large_corner_seat",
  "walk_in_tub", "replacement_tub", "replacement_tub_fixture"];

export const checkSidesFeatureGroups = ["shower_door", "shower_fixture", "grab_bar", "large_corner_seat",
  "replacement_tub", "shower_pan_combo", "corner_caddie", "large_corner_caddie", "soap_dish", "walk_in_tub",
  "shower_seats", "replacement_tub_fixture", "shampoo_shelf", "jetted_tub", "seat_pad", "l_shaped_grab_bar"];

export const ALL_SHOWER_AREA_GROUPS = ["shower_wall", "shower_fixture", "shower_seats", "soap_dish", "grab_bar",
  "shower_door", "shower_arm", "shower_head", "hand_shower_kit", "diverter_trim", "hand_shower_holder", "hand_shower_only",
  "shower_hose", "shower_system", "shower_trim_kit", "valve_trim", "wall_union", "shampoo_shelf", "large_corner_seat",
  "walk_in_tub", "replacement_tub", "replacement_tub_fixture", "ceiling_panels", "shower_head_bundle", "shower_pan_combo",
  "corner_shelf", "body_spray", "shower_rod", "shower_pod", "shower_curb", "pony_wall_glass", "seat_pad"];

export const ALL_VANITY_AREA_GROUPS = ["vanity_faucet", "vanity_sink", "vanity_countertop", "vanity_backsplash",
  ...CONTEXT_MENU_VANITY_ONLY, "vanity_ws_towel_bar", "vanity_drawer_pull", "vanity_middle", "vanity_mirror",
  "vanity_lighting", "vanity_ptrap", "door_handle", "drawer_handle", "vanity_handle"];

export const allShowerSideOptionsGroups = [...showerSideOptionsGroups, "corner_shelf", "body_spray"]

export const VANITY_HANDLES = ["door_handle", "drawer_handle", "vanity_handle"];
